import { Card } from '@/components/Surface'

type TariffProps = {
  mode: 'tariff'
  devices: number
  included: number
  max: number
  onChange: (n: number) => void
  dayRate: number
  extraDevices: number
  extraCost: number
}
type AddonProps = {
  mode: 'addon'
  dayRate: number
  days: number
  cost: number
}

/** Dumb device-pricing widget: renders the quote it's given, never computes price. */
export function DeviceQuote(p: TariffProps | AddonProps) {
  return (
    <Card className="p-4">
      {p.mode === 'tariff' ? (
        <>
          <div className="flex items-center justify-between">
            <span className="text-[14px]">устройства</span>
            <span className="inline-flex items-center gap-4">
              <button className="tap text-[18px] disabled:opacity-30" disabled={p.devices <= p.included}
                onClick={() => p.onChange(p.devices - 1)} aria-label="меньше">−</button>
              <span className="num text-[18px] font-bold w-5 text-center">{p.devices}</span>
              <button className="tap text-[18px] disabled:opacity-30" disabled={p.devices >= p.max}
                onClick={() => p.onChange(p.devices + 1)} style={{ color: 'var(--color-accent)' }} aria-label="больше">+</button>
            </span>
          </div>
          <div className="text-[11.5px] text-[var(--color-muted)] mt-1">{p.included} включено · доп. {p.dayRate.toFixed(2)} ₽/день</div>
          {p.extraDevices > 0 && (
            <div className="flex items-center justify-between text-[12.5px] mt-3 pt-3 border-t border-[var(--color-line)]">
              <span className="text-[var(--color-muted)]">+{p.extraDevices} × {p.dayRate.toFixed(2)} ₽/день</span>
              <span className="num font-bold">+{p.extraCost} ₽</span>
            </div>
          )}
        </>
      ) : (
        <div className="flex items-center justify-between">
          <span className="text-[12.5px] text-[var(--color-muted)]">+1 × {p.dayRate.toFixed(2)} ₽/день × {p.days} дн</span>
          <span className="num text-[22px] font-bold">{p.cost} ₽</span>
        </div>
      )}
    </Card>
  )
}
